var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRetry = function SvgRetry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.667 9.167A6.75 6.75 0 003.751 7.5m-.417-3.333V7.5h3.333",
    stroke: "#F7FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.334 10.833A6.75 6.75 0 0016.251 12.5m.416 3.333V12.5h-3.333",
    stroke: "#F7F7FF"
  }))));
};
export default SvgRetry;